module.exports = __webpack_public_path__ + "img/a08eb78b-6d47-4d31-b3db-8667f47e9892.426b340f.jpg";